import { transactionService } from '@/utils/request'

// 购物车相关接口

// 创建订单-返回支付信息
export function cartList () {
  return transactionService({
    url: 'cart/list',
    method: 'get'
  })
}

// 添加购物车
export function cartAdd (data) {
  return transactionService({
    url: 'cart/add',
    method: 'post',
    data: data
  })
}

// 删除购物车
export function cartRemove (data) {
  return transactionService({
    url: 'cart/remove',
    method: 'post',
    data: data
  })
}

// 修改规格
export function cartUpdateSpecId (data) {
  return transactionService({
    url: 'cart/updateSpecId',
    method: 'post',
    data: data
  })
}

// 结算
export function cartCreateOrder (data) {
  return transactionService({
    url: 'cart/createOrder',
    method: 'post',
    data: data
  })
}

// 未支付或关闭订单 重新添加购物车
export function cartBatchReAdd (data) {
  return transactionService({
    url: 'cart/batchReAdd',
    method: 'post',
    data: data
  })
}
